<template>

<div class="empty">

	<slot></slot>

</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.empty {
	display: flex;
	height: 100%;
	justify-content: center;
	align-items: center;
	font-size: 18px;
	color: var(--color-grey);
}

</style>